import api from '#config/api';

export const createAdelphiFeint = values => api.post('/feints', values);

export const getAllAdelphiFeints = () => api.get('/feints');

export const getAdelphiFeintById = id => api.get(`/feints/${id}`);

export const updateAdelphiFeintById = ({ id, values }) => api.put(`/feints/${id}`, values);

export const deleteAdelphiFeintById = ({ id }) => api.delete(`/feints/${id}`);
